import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'prcins-quick-pay-registration-header',
  templateUrl: './quick-pay-registration-header.component.html',
  styleUrls: ['./quick-pay-registration-header.component.css']
})
export class QuickPayRegistrationHeaderComponent implements OnInit {

  @Input() 
  headerText: string;

  constructor() { }

  ngOnInit() {
  }

}
